import React from "react";
import ForSaleWigsDetails from "./for-sale-wigs-details/for-sale-wigs-details";

const ForSaleWigsDetailsContainer = () => {
    return (
        <>
            <div style={{ padding: 20 }}>
                <ForSaleWigsDetails/>
            </div>
        </>
    )
};

export default ForSaleWigsDetailsContainer;